module.exports = __webpack_public_path__ + "static/media/subICloud4.9285a50e.png";